import DeviceInfo from '@/shared/libs/device-info';

export const getDeviceType = () => {
  let deviceType = 'other';

  if (DeviceInfo.isPhone()) {
    deviceType = 'mobile';
  } else if (DeviceInfo.isTablet()) {
    deviceType = 'tablet';
  }

  return deviceType;
};

export const getRandomParameters = () => {
  const pvrn = Math.floor(1000000 + Math.random() * 9000000);
  const vprn = Math.floor(1000000 + Math.random() * 9000000);
  return { pvrn, vprn };
};
